import { Link } from "react-router-dom";
import { Linkedin, Youtube, Facebook, Instagram } from "lucide-react";
import { CONTACT_EMAILS } from "@/data/content";

const GROUPS = [
  {
    title: "Institute",
    links: [
      { label: "About", to: "/about" },
      { label: "Editorial Standards", to: "/editorial-standards" },
      { label: "Corrections", to: "/contact" },
      { label: "Privacy", to: "/editorial-standards" },
    ],
  },
  {
    title: "Explore",
    links: [
      { label: "Research", to: "/research" },
      { label: "Countries", to: "/countries" },
      { label: "Newsletter", to: "/#newsletter" },
    ],
  },
  {
    title: "Engage",
    links: [
      { label: "Partnerships", to: "/#partnership" },
      { label: "Support", to: "/#support" },
      { label: "Contact", to: "/contact" },
    ],
  },
];

const SOCIALS = [
  { label: "LinkedIn", icon: Linkedin },
  { label: "YouTube", icon: Youtube },
  { label: "Facebook", icon: Facebook },
  { label: "Instagram", icon: Instagram },
];

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="grain bg-atlantic-deep text-white">
      <div className="relative mx-auto max-w-7xl px-5 py-20 lg:px-8">
        <div className="grid grid-cols-1 gap-12 lg:grid-cols-12">
          <div className="lg:col-span-5">
            <p className="font-serif text-2xl font-bold tracking-tight">Atlantic Bridge</p>
            <p className="mt-1 text-[10px] font-semibold uppercase tracking-[0.42em] text-gold">Institute</p>
            <p className="mt-6 max-w-sm font-serif text-lg italic leading-relaxed text-white/70">
              One Atlantic. Shared Histories. Common Futures.
            </p>
            <div className="mt-8 flex gap-3">
              {SOCIALS.map((s) => (
                <a
                  key={s.label}
                  data-testid={`social-${s.label.toLowerCase()}-link`}
                  href="#"
                  onClick={(e) => e.preventDefault()}
                  aria-label={`${s.label} (coming soon)`}
                  className="flex h-10 w-10 items-center justify-center border border-white/20 text-white/70 transition-colors hover:border-gold hover:text-gold"
                >
                  <s.icon size={16} />
                </a>
              ))}
            </div>
          </div>
          {GROUPS.map((g) => (
            <div key={g.title} className="lg:col-span-2">
              <p className="text-[11px] font-semibold uppercase tracking-[0.25em] text-white/45">{g.title}</p>
              <ul className="mt-5 space-y-3">
                {g.links.map((l) => (
                  <li key={l.label}>
                    <Link
                      data-testid={`footer-link-${l.label.toLowerCase().replace(/[^a-z]+/g, "-")}`}
                      to={l.to}
                      className="text-sm text-white/75 transition-colors hover:text-gold"
                    >
                      {l.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
          <div className="lg:col-span-1" aria-hidden="true" />
        </div>
        <div className="mt-16 flex flex-col gap-4 border-t border-white/10 pt-8 sm:flex-row sm:items-center sm:justify-between">
          <p className="text-xs text-white/45">© {new Date().getFullYear()} Atlantic Bridge Institute. All rights reserved.</p>
          <div className="flex flex-wrap gap-x-6 gap-y-2">
            {CONTACT_EMAILS.map((c) => (
              <span
                key={c.label}
                data-testid={`footer-email-${c.label.toLowerCase().replace(/[^a-z]+/g, "-")}`}
                className="text-xs italic text-white/45"
                title={c.note}
              >
                {c.label}: placeholder pending
              </span>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
}
